import styled from "styled-components"

export const TicketHeader = styled.p`
  font-weight: 700;
  font-size: 1.75em;
  line-height: 32px;
  color: ${props => (props.is_featured ? "white" : "#000033")};
  padding-bottom: 8px;
  padding-inline: 0;

  @media (max-width: 768px) {
    padding-left: 0px;
  }
`

export const TicketDetail = styled.p`
  font-weight: 500;
  font-size: 1.05em;
  font-family: "Roboto";
  line-height: 20px;
  color: #888888;
  padding-inline: 0;

  @media (max-width: 768px) {
    padding-left: 0px;
  }
`

export const PriceContainer = styled.div`
  justify-content: space-between;
  margin: 0px;
`

export const TrackPriceText = styled.span`
  font-weight: 700;
  font-size: 1em;
  line-height: 24px;
  color: ${props => (props.is_featured ? "#BBBBBB" : "#000033")};
`

export const TrackPrice = styled.span`
  color: #fa4616;
`

export const SpecialText = styled.span`
  color: #fa4616;
  margin-bottom: 8px;
  font-size: 0.875em;
  font-weight: 700;
  line-height: 16px;
`

export const Price = styled.p`
  font-weight: 700;
  font-size: 2em;
  line-height: 40px;
  color: ${props => (props.is_featured ? "#fff" : "#000033")};
`

export const GrayText = styled.p`
  font-weight: 700;
  font-size: 1em;
  line-height: 24px;
  margin-bottom: 10px;
  color: ${props => (props.is_featured ? "#fff" : "#888888")};
`

export const TicketContentWrapper = styled.div`
  margin-top: 24px;
  padding: 0px;
  border-bottom: 1px solid rgba(0, 0, 51, 0.05);
  padding-bottom: 24px;
  overflow-x: hidden;
  overflow-y: auto;
`

export const TicketContentSpecialWrapper = styled.div`
  margin-top: 24px;
  padding: 32px 24px;
  border-bottom: 1px solid rgba(0, 0, 51, 0.05);
  overflow-x: hidden;
  overflow-y: auto;
  background: #000033;
  border-radius: 8px;
`

export const PriceColumn = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  padding-left: 0px;
  margin-top: 29px;

  @media (max-width: 768px) {
    padding-left: 0px;
    width: 45%;
  }
`

export const PurchaseColumn = styled.div`
  width: 10%;
  text-align: center;
  margin-top: 29px;
`

export const ShowMore = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 1em;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #fa4616;
  cursor: pointer;
  margin-top: 11px;
`

export const ScheduleDetailDiv = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 1.5em;
  line-height: 34px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #fa4616;
  cursor: pointer;
`
export const ScheduleText = styled.p`
  font-weight: 500;
  font-size: 1.2em;
  font-family: "Roboto";
  color: #cccccc;
  line-height: 1.5;
`

export const ScheduleDetailLabel = styled.label`
  margin-right: 10px;
  cursor: pointer;
`
